import api from '@/services/api';
import { Charge } from '@/types/charge';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { chargeKeys } from './use-charges';
import { enrollmentKeys } from './use-enrollments';

export function useConfirmPayment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (chargeId: string) => {
      const response = await api.post<Charge>(`/charge/${chargeId}/confirm-payment`);
      return response.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: chargeKeys.all });
      if (data?.id) {
        queryClient.invalidateQueries({ queryKey: chargeKeys.detail(data.id) });
      }
      if (data?.enrollmentId) {
        queryClient.invalidateQueries({
          queryKey: chargeKeys.byEnrollment(data.enrollmentId),
        });
        queryClient.invalidateQueries({
          queryKey: enrollmentKeys.detail(data.enrollmentId),
        });
        queryClient.invalidateQueries({ queryKey: enrollmentKeys.provider() });
      }
    },
  });
}
